import axios from 'axios';

/**
 * Eigener HTTP-Client für die Anbieterebene.
 *
 * Bewusst eine zweite Instanz neben services/apiClient.js und nicht dieselbe
 * mit einem zweiten Token. Der Grund ist die Abfangkette: der Mandanten-Client
 * ruft bei 401 seinen Abmelde-Rückruf. Liefe die Anbietersicht darüber,
 * würde ein abgelaufenes Anbietertoken die laufende Buchhaltungssitzung
 * mit ausloggen - und umgekehrt.
 *
 * Beide Sitzungen sollen gleichzeitig im selben Browser bestehen können.
 */

const baseURL = import.meta.env.VITE_API_BASE_URL ?? '';

export const platformClient = axios.create({
  baseURL,
  timeout: 20_000,
  headers: { 'Content-Type': 'application/json' },
});

let accessToken = null;
let onUnauthorized = null;

export function setPlatformAccessToken(token) {
  accessToken = token;
}

export function getPlatformAccessToken() {
  return accessToken;
}

export function setPlatformUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

platformClient.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

platformClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Nur der Anbieter-Rückruf, nie der des Mandanten.
    if (error.response?.status === 401 && onUnauthorized) {
      onUnauthorized();
    }
    const body = error.response?.data;
    return Promise.reject({
      status: error.response?.status || 0,
      body,
      message: body?.error?.message || error.message,
      fields: body?.error?.details?.fields,
    });
  },
);

/** Envelope-Auspacker, gleiche Vertragsform wie im Mandantenpfad. */
export async function platformGet(url, params) {
  const { data } = await platformClient.get(url, { params });
  return { items: data.data, meta: data.meta };
}

export async function platformPost(url, body) {
  const { data } = await platformClient.post(url, body);
  return data.data;
}

export async function platformPatch(url, body) {
  const { data } = await platformClient.patch(url, body);
  return data.data;
}

/* DELETE mit Rumpf: das Kürzel muss mitgeschickt werden, damit der Server
   prüfen kann, dass wirklich die gemeinte Firma entfernt wird. axios braucht
   dafür die ausdrückliche data-Option - ein DELETE trägt sonst keinen. */
export async function platformDelete(url, body) {
  const { data } = await platformClient.delete(url, { data: body });
  return data.data;
}
